import React from "react";
import { MdLabelImportant } from "react-icons/md";
const Necessary = () => {
  return (
    <div className="w-full">
      <h2 className="text-[#22BEFF] text-2xl font-bold">
        ক্লাস করার জন্য প্রয়োজন হবে
      </h2>
      <div className="w-full border border-[#22BEFF33] mt-[1rem] rounded-md  gap-8 p-4">
        <div className="flex flex-col gap-4">
         
          <p className="text-gray-400 text-xl flex items-center">
            <MdLabelImportant className="text-[#22BEFF] text-base"/>ইন্টারনেট সংযোগ (ওয়াইফাই বা মোবাইল ইন্টারনেট)
          </p>
          <p className="text-gray-400 text-xl flex items-center">
            <MdLabelImportant className="text-[#22BEFF] text-base"/>স্মার্টফোন অথবা পিসি
          </p>
          
        </div>
      </div>
    </div>
  );
};

export default Necessary;
